import InputColor from './src/InputColor.vue'

/* istanbul ignore next */
InputColor.install = function (Vue) {
    Vue.component(InputColor.name, InputColor)
}

export default InputColor
